import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DatePicker } from 'primeng/datepicker';
import { UnitOfMeasure } from 'src/enums/unitofmeasure.enum';
import Helpers from 'src/shared/helpers';

@Component({
  selector: 'form-row',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './form-row.component.html',
})
export class FormRowComponent {
  @Input() template: string = 'string';
  @Input() model: any;
  @Input() fieldName!: string;
  @Input() disabled: boolean = false;
  @Input() classes: string = '';
  @Input() selectOptions: any[] = [];
  @Input() calendarDataType: string = 'date';
  @Input() hideLabel: boolean = false;

  @Input() dateOptions: any[] = [];
  @Output() toggleOnChangeCallback: EventEmitter<any> = new EventEmitter();

  constructor() {}

  setUnitOfMeasureOwn(event: any) {
    if (event.value !== Helpers.nameof('OWN', UnitOfMeasure)) {
      this.model.unitOfMeasureOwn = null;
    }
  }

  setDateRangeValues(event: any, calendar: DatePicker) {
    const dateRange: Date[] = this.model[this.fieldName];

    if (!dateRange?.length) {
      return;
    }

    if (dateRange[1] === null) {
      dateRange[1] = dateRange[0];
      calendar.updateInputfield();
    }
  }

  toggleOnChange(event: any) {
    this.toggleOnChangeCallback?.emit(event);
  }

  isDateAllowed(date: Date): boolean {
    return this.dateOptions.some(r =>
      date >= r.start &&
      date <= r.end
    );
  }
  isCalendarDateAllowed(calendarDate: any): boolean {
    const actualDate = new Date(
      calendarDate.year,
      calendarDate.month,
      calendarDate.day
    );

    return this.isDateAllowed(actualDate);
  }

  dateFilter = (date: Date | null): boolean => {
  if (!date) {
    return false;
  }

  return this.dateOptions.some(range =>
    date >= range.availableFrom &&
    date <= range.availableTo
  );
};
}
